import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import "./Pagination.css";

function Pagination({ itemsPerPage, totalCount, pageChangeFunction, currentPage }) {
    const [pageCount, setPageCount] = useState(0);

    // Calculate pageCount and validate props
    useEffect(() => {
        const validTotalCount = Math.max(0, Number(totalCount) || 0);
        const validItemsPerPage = Math.max(1, Number(itemsPerPage) || 1);
        const calculatedPageCount = Math.ceil(validTotalCount / validItemsPerPage);
        setPageCount(calculatedPageCount);
    }, [itemsPerPage, totalCount]);

    // Handle page clicks
    const handlePageClick = (event) => {
        const newPage = event.selected + 1; // Convert to 1-based index
        if (pageChangeFunction) pageChangeFunction(newPage);
    };

    // Calculate offsets directly from props
    const validItemsPerPage = Math.max(1, Number(itemsPerPage) || 1);
    const itemOffset = (currentPage - 1) * validItemsPerPage;
    const endOffset = Math.min(itemOffset + validItemsPerPage, totalCount);

    return (
        <div className='flex items-center justify-end mt-3'>
            {/* Uncomment to show entries */}
            {/* <p className="mb-0 text-[#5E6278] text-sm font-medium">
                Showing {itemOffset + 1} to {endOffset} of {totalCount} entries
            </p> */}

            {/* Conditionally render pagination */}
            {pageCount > 0 && (
                <ReactPaginate
                    forcePage={currentPage - 1} // 0-based index
                    pageCount={pageCount}
                    onPageChange={handlePageClick}
                    previousLabel={<IconChevronLeft size={18} />}
                    nextLabel={<IconChevronRight size={18} />}
                    breakLabel="..."
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    // Styling props
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null} // Hide if pageCount=0
                />
            )}
        </div>
    );
}

export default Pagination;
